import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

@Component({
  selector: 'app-default-button',
  templateUrl: './default-button.component.html',
  styleUrls: ['./default-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush // Optional: use OnPush if parent handles loading state properly
})
export class DefaultButtonComponent implements OnInit {
  @Input() label = 'Submit';
  @Input() loadingLabel = 'Processing...';
  @Input() loading = false;
  @Input() disabled = false;
  @Input() icon: string | null = null;
  @Input() type: 'button' | 'submit' = 'button';
  @Input() className = 'btn btn-primary w-100';
  @Input() preventDefault = false;

  @Output() action = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  onClick(event: Event): void {
    if (this.preventDefault && this.type === 'submit') {
      event.preventDefault();
    }

    if (!this.loading && !this.disabled) {
      this.action.emit();
    }
  }
}
